<template>
    <el-dialog
        width="450px"
        title="撤销零担平台原因"
        :before-close="handleClose"
        :visible.sync="revocationVisiable"
        :closeOnClickModal='false'
        class="revocationPlatformDialog"
       >
        <el-form
            class="demo-form">
            <div class="reason">
                <el-form-item class="demo-form">
                    <el-input
                        v-model.trim="remark"
                        type="textarea"
                        :rows="4"
                    ></el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button  @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="confirm">确 认</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { revokeToLtlPlatForm } from '../../../../../api/transportDetails';
export default {
    props: {
        revocationVisiable: {
            type: Boolean,
            default() {
                return false;
            }
        },
        selected: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            remark: ''
        };
    },
    methods: {
        async confirm() {
            const params = this.selected.map(item => {
                const { taskNo, siteCode, carrierCode } = item;
                return {
                    taskNo,
                    siteCode,
                    carrierCode,
                    remark: this.remark
                };
            });
            await revokeToLtlPlatForm(params).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('撤销零担平台成功');
                }
            });
            this.$emit('revocationPlatformOk');
        },
        handleClose() {
            this.$emit('update:revocationVisiable', false);
        }
    }
};
</script>

<style lang="less">
.revocationPlatformDialog{
    .el-dialog__body{
        padding-bottom: 0;
    }
    .el-dialog__footer{
        padding-top: 0;
    }
}
</style>